import { useLayoutEffect, useRef, useState } from 'react';

/**
 * The rendered width of an element, kept current as the layout changes.
 *
 * For decisions that depend on the space actually available — such as whether a
 * figure fits inside the bar segment it belongs to — rather than on an assumed
 * viewport. Measured before paint so the first frame is already correct.
 */
export function useElementWidth<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }

    setWidth(node.clientWidth);

    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) {
        setWidth(entry.contentRect.width);
      }
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, width] as const;
}
